import { EAnexoModulos } from '../components/Anexos';
import * as http from '../helpers/http';
import UploadFilesService from './UploadFiles.service';

class AlarmeSyncService {

    Get = async (): Promise<any> => {
        const result = await http.get(`/alarme-sync`);
        if (result.success) { return result.data }
        return undefined;
    };


}

export default new AlarmeSyncService();
